class SimpleAudio {
  constructor() {
    this.audioData = {}
    this.ready = false

    try {
      window.AudioContext = window.AudioContext || window.webkitAudioContext
      this.audioContext = new AudioContext()
    } catch (err) {
      console.log('Web Audio API is not supported in this browser')
    }
  }

  async preloads(data) {
    if (!this.audioContext) {
      return
    }

    const list = Array.isArray(data) ? data : [data]

    // データを読み込む
    for (let i = 0; i < list.length; i += 1) {
      const name = list[i]

      // データを取得する
      const response = await fetch(name)

      // arrayBufferに変換
      const responseBuffer = await response.arrayBuffer()

      // AudioBufferオブジェクトに変換して保管する
      this.audioData[name] = await this.audioContext.decodeAudioData(responseBuffer)
    }
  }

  play(name, loop = false) {
    if (this.ready) {
      this._start(name, loop)
      return
    }

    this.audioContext.resume().then(() => {
      this.ready = true
      this._start(name, loop)
    })
  }

  _start(name, loop) {
    if (this.audioData[name]) {
      const source = this.audioContext.createBufferSource()
      source.buffer = this.audioData[name]
      source.loop = loop ? true : false
      source.connect(this.audioContext.destination)
      source.start(0)
    }
  }
}